export default __webpack_public_path__ + "static/media/Bebel.deb846e8.png";